import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

import type { OwnedAccount, SiteAccount, Account } from '@hotjar/account';

interface Payment3DS2AuthenticationLookupProps {
  reportedStatus: string | undefined;
  bin: number | undefined;
  threeDSecureVersion: string | undefined;
  account: Account | SiteAccount | OwnedAccount;
}

/**
 * Braintree has returned info on whether client's CC needs additional challenge or is pre-approved
 * @param {string|undefined} reportedStatus The status returned by Braintree.
 * @param {number|undefined} bin Bin number for the payment method.
 * @param {string|undefined} threeDSecureVersion 3ds version of challenge that client will be presented
 */
export function payment3DS2AuthenticationLookup({
  reportedStatus,
  bin,
  threeDSecureVersion,
  account,
}: Payment3DS2AuthenticationLookupProps): void {
  Segment.track('3DS Bank Payment Authentication Lookup Finished', {
    reported_status: reportedStatus ?? 'no_status_reported',
    ...extractAccountGroupingProps(account),
    ...(bin ? { bin } : {}),
    ...(threeDSecureVersion ? { version_of_3ds: threeDSecureVersion } : {}),
  });
}
